/**
 * 司机管理
 */

export default [
    /*  {
        label: '项目管理',
        icon: 'icon-yonghu',
        permission:'project_manage',
        id:'1',
        children: [*/
    {
        label: '项目管理',
        icon: 'icon-jichu',
        path: '/project/manage',
        permission: 'project_manage',
        id:'1-1',
    }
    /*],
  },*/
];

